import { useParams, Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function CategoryFeatured() {
  const { slug } = useParams<{ slug: string }>();
  const filteredCategoryArticles = articles.filter((a) => a.categorySlug === slug).slice(0, 3);
  const categoryArticles = filteredCategoryArticles.length ? filteredCategoryArticles : articles;
  const displayArticles = categoryArticles.length >= 3 ? categoryArticles : articles.slice(0, 3);

  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-4">
          <span className="font-heading text-xs tracking-widest uppercase text-foreground-500 font-semibold">
            精选 · 推荐
          </span>
        </div>

        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-12">
          精选合集
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {displayArticles.map((article, index) => {
            if (index === 0) {
              return (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group relative rounded-2xl bg-primary-500 p-8 flex flex-col justify-between min-h-[360px] overflow-hidden transition-transform duration-300 hover:-translate-y-1 cursor-pointer"
                >
                  <div className="absolute top-6 left-6">
                    <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-background-50/20 text-background-50 text-xs font-bold">
                      精
                    </span>
                  </div>
                  <div className="mt-auto">
                    <span className="text-background-50/80 text-xs font-medium bg-background-50/15 px-2.5 py-1 rounded-full">
                      {article.category}
                    </span>
                    <h3 className="mt-4 text-2xl font-bold text-background-50 leading-snug group-hover:underline">
                      {article.title}
                    </h3>
                    <p className="mt-3 text-background-50/60 text-sm leading-relaxed line-clamp-2">
                      {article.excerpt}
                    </p>
                  </div>
                </Link>
              );
            }

            if (index === 1) {
              return (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group relative rounded-2xl overflow-hidden min-h-[360px] transition-transform duration-300 hover:-translate-y-1 cursor-pointer"
                >
                  <img
                    src={article.imageUrl}
                    alt={article.imageAlt}
                    className="absolute inset-0 w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                  <div className="absolute top-6 left-6">
                    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium">
                      <i className="ri-fire-line w-3 h-3 flex items-center justify-center" />
                      {article.category}
                    </span>
                  </div>
                  <div className="absolute bottom-0 left-0 p-6">
                    <h3 className="text-2xl font-bold text-background-50 leading-snug group-hover:underline">
                      {article.title}
                    </h3>
                  </div>
                </Link>
              );
            }

            return (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group rounded-2xl bg-background-50 overflow-hidden transition-transform duration-300 hover:-translate-y-1 cursor-pointer flex flex-col"
              >
                <div className="p-8 flex flex-col flex-1">
                  <h3 className="font-heading text-2xl font-bold text-foreground-950 leading-snug group-hover:text-accent-500 transition-colors">
                    {article.title}
                  </h3>
                  <p className="mt-3 text-foreground-500 text-sm leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="mt-auto pt-6 flex items-center gap-2 text-xs text-foreground-400">
                    <span>{article.publishDate}</span>
                    <span>·</span>
                    <span>{article.readTime}</span>
                  </div>
                </div>
                <div className="h-40 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.imageAlt}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}